import React from 'react'
import ReactApexChart from 'react-apexcharts'
import { useSelector } from 'react-redux';

function StackChart({ data, labels, colors, initialHiddenSeries }) {
    const maintheme = useSelector((state) => state.themeData.maintheme);

    // Early return if no data
    if (!data || !labels || data.length === 0 || labels.length === 0) {
        return (
            <div id="chart" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
                لاتوجد بيانات
            </div>
        );
    }

    const chartHeight = Math.max(500, labels.length * 85);

    const state = {
        series: data,
        options: {
            chart: {
                toolbar: {
                    show: false
                },
                type: 'bar',
                height: chartHeight,
                events: {
                    mounted: (chart) => {
                        if (initialHiddenSeries) {
                            initialHiddenSeries.forEach(name => {
                                chart.toggleSeries(name);
                            });
                        }
                    }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: '70%',
                    dataLabels: {
                        position: 'top'
                    }
                },
            },
            dataLabels: {
                enabled: true,
                textAnchor: 'start',
                style: {
                    fontSize: '11px',
                    colors: ["#fff"],
                    fontFamily: 'Cairo-Bold'
                },
                formatter: function (val) {
                    return val > 0 ? val : '';
                },
                offsetX: 10,
                dropShadow: {
                    enabled: true,
                    top: 1,
                    left: 1,
                    blur: 1,
                    color: '#000',
                    opacity: 0.45
                }
            },
            stroke: {
                show: true,
                width: 1,
                colors: ['#fff']
            },
            title: {
                text: ''
            },
            xaxis: {
                categories: labels,
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                title: {
                    text: 'الوزن (بالطن)',
                    style: {
                        fontFamily: 'Cairo-Medium'
                    }
                },
                labels: {
                    style: {
                        fontFamily: 'Cairo-Medium',
                        fontSize: '12px'
                    }
                }
            },
            yaxis: {
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                labels: {
                    align: 'center',
                    minWidth: 200,
                    maxWidth: 600,
                    style: {
                        fontFamily: 'Cairo-Medium',
                        fontSize: '13px'
                    },
                }
            },
            grid: {
                padding: {
                    left: 20
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'center',
                fontSize: '14px',
                fontFamily: 'Cairo-Medium',
                margin: 10
            },
            tooltip: {
                enabled: true,
                shared: true,
                intersect: false,
                theme: 'light',
                style: {
                    fontSize: '12px',
                    fontFamily: 'Cairo-Medium'
                },
                y: {
                    formatter: function (val) {
                        return val + " طن"
                    }
                }
            },
            colors: colors || [maintheme?.primary, maintheme?.secondary, maintheme?.red || '#ff5252', maintheme?.yellow || '#c8b803'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
    };

    return (
        <div id="chart" style={{ width: '100%', height: 'auto' }}>
            <ReactApexChart options={state.options} series={state.series} type="bar" height={state.options.chart.height} />
        </div>
    )
}

export default StackChart